module.exports = __webpack_public_path__ + "static/img/pr.0e5e97b9.svg";